import { useTheme } from '@mui/material/styles';
import { getPortalTokens, DEFAULT_PORTAL_MODE } from './portalTheme';

/** Active portal tokens from the MUI theme (respects light/dark when mode is switched). */
export function usePortalTokens() {
  const theme = useTheme();
  return theme.portal ?? getPortalTokens(theme.palette?.mode ?? DEFAULT_PORTAL_MODE);
}
